import {getDeliveryDataRecord} from '../../api/newOwner'

const newOwner = {
    namespaced: true,
    state: {
        deliveryDataRecord: {
            isSign: false
        }
    },
    mutations: {},
    actions: {
        async getDeliveryDataRecord({state}, payload) {
            // const page = {
            //     roomId: payload.roomId
            // }
            let req = await getDeliveryDataRecord(payload.data.roomId, payload.data.businessType);
            state.deliveryDataRecord = {};
            state.deliveryDataRecord = req.data.result;
        }
    }
}

export default newOwner
